import React, { FC } from "react";
import classNames from "classnames";
import { BemHelper } from "../../utils";

const bem = new BemHelper("dots-loader");

export type Props = {
  styleWrapper?: React.CSSProperties;
  theme?: "light" | "dark";
};

export const DotsLoader: FC<Props> = ({ styleWrapper = {}, theme = "light" }) => {
  return (
    <div className={classNames([bem.block()])} style={styleWrapper}>
      <div
        className={classNames([bem.modifier("dot"), theme === "dark" && bem.modifier("dark")])}
      />
      <div
        className={classNames([bem.modifier("dot"), theme === "dark" && bem.modifier("dark")])}
      />
      <div
        className={classNames([bem.modifier("dot"), theme === "dark" && bem.modifier("dark")])}
      />
    </div>
  );
};
